export function isValidElement(element) {
    return (isVueOptions(element) ||
        (element &&
            typeof element === 'object' &&
            'componentOptions' in element &&
            'context' in element &&
            element.tag !== undefined)); // remove text node
}
export function isVnode(element) {
    return (element &&
        typeof element === 'object' &&
        'componentOptions' in element &&
        'context' in element &&
        element.tag !== undefined);
}
export function isVueOptions(options) {
    return (options &&
        (typeof options.template === 'string' ||
            typeof options.render === 'function'));
}
export function composeExport(s0, s1) {
    return Object.assign(s0, s1);
}
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vant/esm/__builtins__/shared/utils.js
// module id = null
// module chunks = 